import React from "react";

type Props = {
  children: JSX.Element;
};

const Header = (props: Props) => {
  const { children } = props;
  return (
    <header className="bg-white px-3 py-4 border-b border-solid border-borderColor">
      {children}
    </header>
  );
};

export default Header;
